export default "/images/vendor/flag-icon-css/flags/1x1/ls.svg?cddead61f832a10065e915b2c41e04d6";